























































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { freightFindGood, address, area, addOrderFreight, modifyOrderFreight} from "@/utils/api";
import { warning, success } from "@/utils/find";
@Component
export default class freightEdit extends Vue {
  disabledLoading:boolean=false;//确定按钮遮罩
  loading:boolean=false;//加载遮罩
  templateName:string='';//模板名称
  type:string='0';//单选选择哪个
  orderAmount:number=0;//每不满
  freightAmount: number=0;//每不满
  fixedFreightAmount: number=0;//固定
  isBuiltIn:boolean=false;//是否为内置模板
  prohibit:boolean=false;//计费规则禁止输入
  allAddress:Array<object>=[];//地址接口
  isadd:Boolean=true;//是否为新增
  builtIn:Array<object>=[];//内置地址全选数组

  @Prop(Object) orderData!: Object;
  @Watch('orderData',{immediate: true, deep: true})
  onChildChanged(val: Object, oldVal: Object) {
    if(val['added']){
      this.isadd=((val['added'] as any) as Boolean);
      this.templateName='';//模板名称
      this.isBuiltIn=false;
      this.orderAmount=0;//每不满
      this.freightAmount=0;//每不满
      this.fixedFreightAmount=0;//固定
    }else{
      this.isadd=((val['added'] as any) as Boolean);
      if(val['data']['defaulted'] as any==0){
        this.isBuiltIn=false;
      }else{
        this.isBuiltIn=true;
      }
      this.freightFindGood();
    }
    this.address();
  }
  // 地址列表
  address(){
    this.loading=true;
    address().then((data:any)=>{
      let address=data;
      let datas=[];
      let arr = [];
      address.forEach(item=>{
        item['disable'] =false;
        (item['isIndeterminate'] as Boolean) =false;
        (item['checkAll'] as Boolean) =false;
        item['checkedCities'] =[];
        item['addressInfos']=[];
        (item['checkedCountLength'] as Number) =0;
        item.childList.forEach(ite=>{
          ite['disable'] =false;
          let address={provinceName: (item['addressName'] as String), provinceId: (item['addressId'] as Number), cityName: (ite['addressName'] as String), cityId: (ite['addressId'] as Number)};
          datas.push((address as never));
        })
        arr.push(item as never)
      })
      this.builtIn=datas;
      let templateId='';
      if(this.orderData['data']){
        templateId=this.orderData['data']['templateId'];
        this.orderData['data']['addressInfos'].forEach(item=>{
          let ins=arr.findIndex(s=>s['addressId']==item.provinceId);
          if (ins >= 0) {
            (arr[ins]['checkedCities'] as any).push(item.cityId);
            (arr[ins]['addressInfos'] as any).push(item);
          }
        });
        arr.forEach(item=>{
          if((item['checkedCities'] as any).length>0){
            if((item['checkedCities'] as any).length==(item['childList'] as any).length){
              (item['checkAll'] as boolean)=true;
              (item['isIndeterminate'] as boolean)=false;
            }else{
              (item['checkAll'] as boolean)=false;
              (item['isIndeterminate'] as boolean)=true;
            }
          }
        })
      }
      area({templateId}).then((data:any)=>{
        let ban=data;
        ban.forEach(i=>{
          let index=arr.findIndex(s=>s['addressId']==i.provinceId)
          if (index >= 0) {
            let inds=(arr[index]['childList'] as any).findIndex(x=>x.addressId==i.cityId);
            (arr[index]['childList'][inds]['disable'] as Boolean)=true;
          }
        })
        arr.forEach(item=>{
          let num=0;
          (item['childList'] as any).forEach(o=>{
            if(o.disable==true){
              num++;
            }
          });
          (item['disable'] as Boolean) = (item['childList'] as any).length==num?true:false;
        })
        this.allAddress=arr;
      }).finally(()=>{
        this.loading=false;
      })
    })
  }

  // 查询模板详情
  freightFindGood(){
    freightFindGood({
      templateId:this.orderData['data']['id']
    }).then((data:any)=>{
        this.templateName=data['templateName'];
        this.type=data['type'].toString();
        if(data['type']==0){
          this.freightAmount=data.freightAmount;
          this.orderAmount=data.orderAmount;
          this.prohibit=false;
        }else{
          this.fixedFreightAmount=data.freightAmount;
          this.prohibit=true;
        }
    })
  }
  // 多选地址
  handleCheckAllChange(val,index) {
    let list=[];
    (this.allAddress[index]['childList'] as any).forEach(item=>{
      if(!item.disable){
        list.push(item.addressId as never)
      }
    });
    (this.allAddress[index]['checkedCities'] as any)=val ? list : [];
    (this.allAddress[index]['isIndeterminate'] as Boolean) = false;
    let array=[];
    (this.allAddress[index]['childList'] as any).forEach(item=>{
      if(!item.disable){
        let obj={
          provinceName:this.allAddress[index]['addressName'] as String,
          provinceId:this.allAddress[index]['addressId'] as Number,
          cityName:item.addressName as String,
          cityId:item.addressId as Number
        }
        array.push(obj as never)
      }
    });
    (this.allAddress[index]['addressInfos'] as any)=val ? array : [];
    if(val){
      (this.allAddress[index]['checkedCountLength'] as Number)=list.length;
      if(list.length==(this.allAddress[index]['childList'] as any).length){
        (this.allAddress[index]['checkAll'] as Boolean) = true;
        (this.allAddress[index]['isIndeterminate'] as Boolean) = false;
      }else{
        (this.allAddress[index]['checkAll'] as Boolean) = false;
        (this.allAddress[index]['isIndeterminate'] as Boolean) = true;
      }
    }else{
      (this.allAddress[index]['checkedCountLength'] as Number)=0;
    }
  }
  // 多选地址
  handleCheckedCitiesChange(value,index) {
    if(value.length>0){
      (this.allAddress[index]['checkedCountLength'] as Number)=value.length;
      let checkedCount=value.length;
      (this.allAddress[index]['checkAll'] as Boolean) = checkedCount === (this.allAddress[index]['childList'] as any).length;
      (this.allAddress[index]['isIndeterminate'] as Boolean) = checkedCount > 0 && checkedCount < (this.allAddress[index]['childList'] as any).length;
      let ary=[];
      value.forEach(element => {
        let inds=(this.allAddress[index]['childList'] as any).findIndex(item=>{
          return element==item.addressId
        })
        let objs={
          provinceName:this.allAddress[index]['addressName'] as String,
          provinceId:this.allAddress[index]['addressId'] as Number,
          cityName:this.allAddress[index]['childList'][inds]['addressName'],
          cityId:this.allAddress[index]['childList'][inds]['addressId']
        }
        ary.push(objs as never)
      });
      (this.allAddress[index]['addressInfos'] as any)=ary;
    }else{
      (this.allAddress[index]['addressInfos'] as any)=[];
      (this.allAddress[index]['checkAll'] as Boolean) = false;
      (this.allAddress[index]['isIndeterminate'] as Boolean) = false;
      (this.allAddress[index]['checkedCountLength'] as Number)=0;
    }
  }
  // 计费规则单选框
  charging(val){
    if(val==0){
      this.prohibit=false;
    }else{
      this.prohibit=true;
    }
  }
  // 确定修改
  determine(){
    let that=this;
    let addressList=[];
    this.allAddress.forEach(item=>{
      if((item['addressInfos'] as any).length>0){
        addressList=addressList.concat(item['addressInfos'])
      }
    });
    let templateName=that.templateName;
    let isBuiltIn=that.isBuiltIn;//是否为内置模板
    let type=that.type;
    let orderAmount=that.orderAmount;//每不满
    let freightAmount=that.freightAmount;//每不满
    let fixedFreightAmount=that.fixedFreightAmount;//固定
    let isadd=that.isadd;//是否新增
    if(templateName==''){
      warning('请输入模板名称');
    }else if(!isBuiltIn && addressList.length<1){
      warning('请选择配送区域');
    }else if(type=='0' && (orderAmount==0 || freightAmount==0)){
      warning('请输入计费规则金额');
    }else if(type=='2' && fixedFreightAmount==0){
      warning('请输入计费规则金额');
    }else{
      this.disabledLoading=true;
      if(isadd){
        if(type=='0'){
          orderAmount=orderAmount;
          freightAmount=freightAmount;
        }else{
          orderAmount=0;
          freightAmount=fixedFreightAmount;
        }
        let data={
          addressInfos: addressList,
          defaulted: 0,
          freightAmount: freightAmount,
          orderAmount: orderAmount,
          templateName: templateName,
          type: type
        }
        that.addOrderFreight(data);
      }else{
        let addressInfos:Array<object>=[];
        if(isBuiltIn){
          addressInfos=that.builtIn;
        }else{
          addressInfos=addressList;
        }
        if(type=='0'){
          orderAmount=orderAmount;
          freightAmount=freightAmount;
        }else{
          orderAmount=0;
          freightAmount=fixedFreightAmount;
        }
        let data=JSON.parse(JSON.stringify(this.orderData['data']));
        data['addressInfos']=(addressInfos as Array<Object>);
        data['freightAmount']=freightAmount;
        data['orderAmount']=orderAmount;
        data['templateName']=templateName;
        data['type']=type;
        that.modifyOrderFreight(data);
      }
    }
  }
  // 新增运费模板
  addOrderFreight(data){
    addOrderFreight(data).then(res=>{
      success('新增订单运费模板成功');
      this.$emit('close');
      this.orderAmount=0;//每不满
      this.freightAmount=0;//每不满
      this.fixedFreightAmount=0;//固定
    }).finally(()=>{
      this.disabledLoading=false;
    })
  }
  // 编辑运费模板
  modifyOrderFreight(data){
    modifyOrderFreight(data).then(res=>{
      success('修改订单运费模板成功');
      this.$emit('close');
      this.orderAmount=0;//每不满
      this.freightAmount=0;//每不满
      this.fixedFreightAmount=0;//固定
    }).finally(()=>{
      this.disabledLoading=false;
    })
  }
  closes(){
    this.$emit('close');
  }
}
